import { render, staticRenderFns } from "./PackingTaskList.vue?vue&type=template&id=1f345c89"
import script from "./PackingTaskList.vue?vue&type=script&lang=js"
export * from "./PackingTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports